@import 'db-ui-core.general';
@import 'cards';

:host {
  @extend html;
  @extend body;
}
